"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Timezone = exports.LocationType = exports.Type = exports.Filter = void 0;
var Filter;
(function (Filter) {
    Filter["Radio"] = "radio";
    Filter["Checkbox"] = "checkbox";
    Filter["Multiselect"] = "multiselect";
})(Filter = exports.Filter || (exports.Filter = {}));
var Type;
(function (Type) {
    Type["Schedule"] = "schedule";
})(Type = exports.Type || (exports.Type = {}));
var LocationType;
(function (LocationType) {
    LocationType["SoCntr"] = "SO_CNTR";
    LocationType["SoSP"] = "SO_SP";
})(LocationType = exports.LocationType || (exports.LocationType = {}));
var Timezone;
(function (Timezone) {
    Timezone["AmericaAtikokan"] = "America/Atikokan";
    Timezone["AmericaNipigon"] = "America/Nipigon";
    Timezone["AmericaRainyRiver"] = "America/Rainy_River";
    Timezone["AmericaThunderBay"] = "America/Thunder_Bay";
    Timezone["AmericaToronto"] = "America/Toronto";
    Timezone["AmericaWinnipeg"] = "America/Winnipeg";
})(Timezone = exports.Timezone || (exports.Timezone = {}));
